export default {
  // =============================================================================
  // ADMIN LAYOUT ROUTES
  // =============================================================================
  path: '/admin',
  component: () => import('../layouts/admin/Main.vue'),
  meta: {role: ['admin']},
  children: [
    {
      path: '',
      name: 'adminHome',
      component: () => import('../views/admin/Home.vue'),
      meta : {
        pageTitle: 'الرئيسية',
        role: ['admin']
      },
    },
    {
      path: 'profile',
      component: () => import('../views/profile/Profile.vue'),
      meta: {
        parent: '',
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'الصفحة الشخصية', active: true},
        ],
        pageTitle: 'الصفحة الشخصية',
        role: ['admin']
      },
    },
    {
      path: 'students',
      name: 'adminStudents',
      component: () => import('../views/admin/students/Students.vue'),
      meta: {
        breadcrumb: [
          { title: 'Home', url: '/admin' },
          { title: 'الطلبة', active: true},
        ],
        pageTitle: 'الطلبة',
        role: ['view_students']
      },
    },
    {
      path: 'students/:student_id/enroll_courses',
      name: 'studentCourses',
      component: () => import('../views/admin/students/StudentCourses.vue'),
      meta: {
        breadcrumb: [
          { title: 'Home', url: '/admin' },
          { title: 'الطلبة', url: '/admin/students'},
          { title: 'المواد الدراسية', active: true},
        ],
        pageTitle: 'المواد الدراسية للطالب',
        role: ['update_students']
      },
    },
    {
      path: 'teachers',
      name: 'adminTeachers',
      component: () => import('../views/admin/Teachers.vue'),
      meta: {
        breadcrumb: [
          { title: 'Home', url: '/admin' },
          { title: 'أعضاء هيئة التدريس', active: true},
        ],
        pageTitle: 'أعضاء هيئة التدريس',

        role: ['view_teachers']
      },
    },
    {
      path: 'courses',
      name: 'adminCourses',
      component: () => import('../views/admin/courses/Courses.vue'),
      meta: {
        breadcrumb: [
          { title: 'Home', url: '/admin' },
          { title: 'المواد الدراسية', active: true},
        ],
        pageTitle: 'المواد الدراسية',
        role: ['view_courses']
      },
    },
    {
      path: 'user_roles',
      name: 'adminUserRoles',
      component: () => import('../views/admin/admins/UserRoles.vue'),
      meta: {
        breadcrumb: [
          { title: 'Home', url: '/admin' },
          { title: 'إدارة صلاحيات المستخدمين', active: true},
        ],
        pageTitle: 'إدارة صلاحيات المستخدمين',
        role: ['view_roles']
      },
    },
    {
      path: 'terms',
      name: 'adminTerms',
      component: () => import('../views/admin/Terms.vue'),
      meta: {
        breadcrumb: [
          { title: 'Home', url: '/admin' },
          { title: 'الفصول الدراسية', active: true},
        ],
        pageTitle: 'الفصول الدراسية',
        role: ['view_terms']
      },
    },
    {
      path: 'terms/:term_id',
      name: 'adminTerm',
      component: () => import('../views/admin/CoursesTerm.vue'),
      meta: {
        parent: 'terms',
        breadcrumb: [
          { title: 'Home', url: '/admin' },
          { title: 'الفصول الدراسية', url: '/admin/terms' },
          { title: 'مواد الفصل الدراسي', active: true},
        ],
        pageTitle: 'مواد الفصل الدراسي',
        backButton: true,
        role: ['view_terms']
      },
    },
  ],
}
